export const UPDATE_PROVISIONAL_OFFER_REQUEST = 'UPDATE_PROVISIONAL_OFFER_REQUEST';
export const UPDATE_PROVISIONAL_OFFER_SUCCESS = 'UPDATE_PROVISIONAL_OFFER_SUCCESS';
export const UPDATE_PROVISIONAL_OFFER_FAILURE = 'UPDATE_PROVISIONAL_OFFER_FAILURE';

export const updateProvisionalOfferRequest = params => ({
  type: UPDATE_PROVISIONAL_OFFER_REQUEST,
  params,
});

export const updateProvisionalOfferSuccess = payload => ({
  type: UPDATE_PROVISIONAL_OFFER_SUCCESS,
  payload,
});

export const updateProvisionalOfferFailure = error => ({
  type: UPDATE_PROVISIONAL_OFFER_FAILURE,
  payload: error,
});
